import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettingsinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.15,
		d: "M10.326 7.674a1.875 1.875 0 1 1-2.652 2.652 1.875 1.875 0 0 1 2.652-2.652"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.15,
		d: "m11.137 3.09.437.145c.4.134.671.509.671.931v.628c0 .534.426.97.96.98l.629.014a.98.98 0 0 1 .856.543l.207.412a.98.98 0 0 1-.184 1.133l-.444.444a.98.98 0 0 0-.015 1.372l.435.455a.98.98 0 0 1 .222.989l-.146.437a.98.98 0 0 1-.93.671h-.628a.98.98 0 0 0-.981.96l-.014.629a.98.98 0 0 1-.542.856l-.412.207a.98.98 0 0 1-1.133-.184l-.444-.444a.98.98 0 0 0-1.372-.015l-.455.435a.98.98 0 0 1-.99.222l-.436-.146a.98.98 0 0 1-.672-.93v-.628a.98.98 0 0 0-.96-.981l-.628-.014a.98.98 0 0 1-.857-.542l-.206-.412a.98.98 0 0 1 .184-1.133l.444-.444a.98.98 0 0 0 .015-1.372l-.435-.455a.98.98 0 0 1-.223-.99l.146-.437a.98.98 0 0 1 .93-.671h.628a.98.98 0 0 0 .981-.96l.014-.629a.99.99 0 0 1 .543-.856l.412-.207a.98.98 0 0 1 1.133.184l.444.444a.98.98 0 0 0 1.372.015l.455-.435a.98.98 0 0 1 .989-.221",
		clipRule: "evenodd"
	})]
});
export default SvgSettingsinline;
